import {useState,useEffect} from 'react';
import { Flex, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, useToast} from '@chakra-ui/react'
import KnjigaView from './KnjigaView';
import { getKnjigaById } from "../../util/apiKnjiga";

const KnjigaControl = ({knjigaid, readonly, onCloseControl, onSave,size='xs'}) => {
    const toast=useToast();
    const [knjiga,setKnjiga]=useState({});
    const [errmsg,setErrmsg]=useState("");
    /*const fetchKnjigaById=async()=>{
        try {
            
            let res=await getKnjigaById(knjigaid);
            if (res.status===200) {
                let _k=res.res[0];
                _k.id=knjigaid;
                setKnjiga(_k);
            } else {
                throw new Error(res.message);
            }
            
        } catch (error) {
            setErrmsg(error.message);
        }
        
    }
    useEffect(() => {
        //onOpen();
       
        if (knjigaid>0) {
            fetchKnjigaById();    
        }
        
        
    }, [knjigaid]);
    */
   useEffect(() => {
    const fetchKnjigaById = async () => {
        try {
            let res = await getKnjigaById(knjigaid);
            if (res.status === 200) {
                let _k = res.res[0];
                _k.id = knjigaid;
                setKnjiga(_k);
            } else {
                throw new Error(res.message);
            }
        } catch (error) {
            setErrmsg(error.message);
        }
    };

    if (knjigaid > 0) {
        fetchKnjigaById();
    }
}, [knjigaid]);

    const ShowErr=()=>{
        if (errmsg!=="") {
            toast({
                title:"Greška u podacima.",
                status:"error",
                description:errmsg,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
            setErrmsg("");
        }
    }
    

    const ShowKnjiga=()=>{
        if (knjigaid===0) {
            return (<KnjigaView knjiga={{}} readonly={readonly} onCancel={onCloseControl} onSave={onSave}></KnjigaView>)
        } else {
        if (knjiga.id!==undefined) {
            // return (<KnjigaView knjiga={knjiga}></KnjigaView>)
            return (<KnjigaView knjiga={knjiga} readonly={readonly} onCancel={onCloseControl} onSave={onSave}></KnjigaView>)
        }
    }
    }
    
    return (
        <Drawer placement='right' size={'lg'} onClose={onCloseControl} isOpen={true}>
             <DrawerOverlay/>
                <DrawerContent roundedTopLeft={'md'}>
                    <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                        Knjiga
                    </DrawerHeader>
                    <DrawerBody>
                        <Flex direction={'column'} scrollBehavior={'auto'}>
                            {ShowKnjiga()}
                            {ShowErr()}
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
        </Drawer>
        
            
        
    );
}

export default KnjigaControl;
